/**
 * Scoped entity lists that manage environment via their own filters instead of
 * the sidebar multi-environment injection.
 *
 * Register a list by:
 * - `filterKeys`: Redux entityFilters namespace (`filterKey` prop on NewEntityList / filters).
 *   Also skips list column cache and filter persistence (recipients selection is per-modal, not per-campaign key).
 * - `entityShowSelectedValues`: internal entityShowSelected filter value on that namespace
 */
export const LIST_GLOBAL_MULTI_ENVIRONMENT_SKIP = {
    filterKeys: ['recipientsAccounts', 'recipientsContacts', 'campaignAccounts'],
    entityShowSelectedValues: ['campaign', 'marketingCampaigns'],
};
